// Alpine
import './alpine.js';

// Breakpoints
import { displayCurrentBreakpoint } from './breakpoints.js';

// Chamber of Commerce
import { checkCocNumber } from './coc.js';

// Filter
import { initProjectsFilter } from './filter.js';

// Scroll
import { initHeaderScrollEffect, initBottomScroll, initConsultationScroll, initAnchorScroll } from './scroll.js';

// Sliders
import { initExpertisesSlider, initProjectsSlider, initLogosSlider, initGallerySlider, initTeamSlider } from './sliders.js';

// Video
import { initHlsVideo } from './video.js';


document.addEventListener(
	'DOMContentLoaded',
	() => {
		// Breakpoints
		displayCurrentBreakpoint();

		// Chamber of Commerce
		checkCocNumber();

		// Filter
		initProjectsFilter();

		// Scroll
		initHeaderScrollEffect();
		initBottomScroll();
		initConsultationScroll();
		initAnchorScroll();

		// Sliders
		initExpertisesSlider();
		initProjectsSlider();
		initLogosSlider();
		initGallerySlider();
		initTeamSlider();

		// Video
		initHlsVideo();
	},
	{ passive: true }
);

window.addEventListener(
	'resize',
	() => {
		// Breakpoints
		displayCurrentBreakpoint();
	},
	{ passive: true }
);
